import { IndexTable, Text } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { getInventoryStockById } from '../../../services/inventoriesService';

const InventoryAddStockTable = ({ product, inventory, onAddQty }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];
  const [found, setFound] = useState(initialSold(product));

  useEffect(() => {
    const qtys = product.variants
      .map(({ barcode }) => ({
        barcode,
        qty: found.find((d) => d.barcode === barcode)?.qty ?? 0,
      }))
      .filter(({ qty }) => qty !== 0);

    onAddQty(qtys);
    getInventoryStockById(inventory.deposit.id, inventory.id, { product: product.id });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, found]);

  return (
    <IndexTable headings={headings} itemCount={2} selectable={false} lastColumnSticky={true}>
      <QtyDepositOriginStockRow product={product} found={found} />
      <QtyInventoryStockRow inventory={inventory} product={product} found={found} />
      <QtyInputStockRow product={product} found={found} setFound={setFound} />
    </IndexTable>
  );
};

const initialSold = (product) =>
  product.variants.map(({ barcode }) => {
    return {
      qty: 0,
      barcode,
    };
  });

const QtyDepositOriginStockRow = ({ product, found }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          STOCK TEÓRICO
        </Text>
      </IndexTable.Cell>
      {stockAtKey(product, 'inventoryStock').map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.stockQtyExpected}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {stockAtKey(product, 'inventoryStock').reduce((acc, cur) => acc + cur.stockQtyExpected, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInventoryStockRow = ({ product, found }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          INVENTARIADO
        </Text>
      </IndexTable.Cell>
      {stockAtKey(product, 'inventoryStock').map((s, i) => {
        return (
          <IndexTable.Cell key={i}>
            <Text alignment="center" variant="headingXs" fontWeight="regular">
              {s.stockQtyFound}{' '}
              {found.find((t) => t.barcode === s.barcode).qty !== 0
                ? ' -> ' + (s.stockQtyFound + found.find((t) => t.barcode === s.barcode).qty)
                : ''}
            </Text>
          </IndexTable.Cell>
        );
      })}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {stockAtKey(product, 'inventoryStock').reduce((acc, cur) => acc + cur.stockQtyFound, 0)}{' '}
          {found.reduce((acc, cur) => acc + cur.qty, 0)
            ? ' -> ' +
              (stockAtKey(product, 'inventoryStock').reduce((acc, cur) => acc + cur.stockQtyFound, 0) +
                found.reduce((acc, cur) => acc + cur.qty, 0))
            : ''}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInputStockRow = ({ product, found, setFound }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          AÑADIDO
        </Text>
      </IndexTable.Cell>
      {product.variants
        .map((v) => found.find((d) => d.barcode === v.barcode))
        .map((d, i) => (
          <IndexTable.Cell key={i}>
            <input
              type="number"
              value={d.qty}
              style={{ width: '40px', borderBottom: '1px solid black', textAlign: 'center' }}
              onChange={(e) =>
                setFound([
                  ...found.filter((ps) => ps.barcode !== d.barcode),
                  {
                    barcode: d.barcode,
                    qty: e.target.value ? parseInt(e.target.value) : 0,
                  },
                ])
              }
            />
          </IndexTable.Cell>
        ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {found.reduce((acc, cur) => acc + cur.qty, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const stockAtKey = (product, key) =>
  product.variants.map((v) => {
    const s = product[key].find((s) => v.barcode === s.barcode);
    return s;
  });

export default InventoryAddStockTable;
